import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-103" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-xl text-center" data-id="element-104" data-mp="1o3dj01a9xtlv">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-navy-light text-teal" data-id="element-105" data-mp="223odrfepfscb">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-106" data-mp="1x5d1ky0xt5qx" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-navy sm:text-2xl" data-id="element-107" data-mp="19dzcd0y31qa6">
          La nostra garanzia «Zero Rischi»
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-navy/60" data-id="element-108" data-mp="14dtfn6cyhdl8">
          Prova Arte Pronta per 7 giorni. Usalo in classe, stampa le schede,
          proietta le lezioni. Se non ti fa risparmiare ore di stress e i tuoi
          studenti non sono più felici, scrivici: ti rimborseremo ogni
          centesimo. E potrai tenere i 5 Bonus come regalo.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-teal underline underline-offset-4 transition-colors hover:text-teal-dark" data-id="element-109" data-mp="ln2a6fw3a7c4">
          Leggi le domande frequenti
        </a>
      </div>
    </section>;
}